import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/totalPass";
import { GetTotalPass } from "../../reducers/totalPass";

export interface TotalPassDetalleDispatcher {
  clearTotalPass: () => Promise<Preview<void>>;
  getTotalPass: (idTotalPass: any) => Promise<Preview<GetTotalPass>>;
}

export const totalPassDetalleDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => TotalPassDetalleDispatcher = dispatch => ({
  clearTotalPass: () => {
    return dispatch(actions.clearTotalPass());
  },
  getTotalPass: (idTotalPass: any) => {
    return dispatch(actions.getTotalPass(idTotalPass));
  }
});
